"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var PromiseClient_1 = require("./PromiseClient");
var template_1 = require("./template");
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client(login, userOption) {
        if (userOption === void 0) { userOption = {}; }
        var _this = _super.call(this, userOption) || this;
        _this.login = login;
        _this.loginStatus = 'none';
        _this.heartbeatTimer = null;
        _this.heartbeatQueue = [];
        _this.messageQueue = [];
        _this.timeoutCount = 0;
        _this._onPacket = function (packet) {
            var type = template_1.decodeTemplateName(packet);
            // console.log('packet type', type, packet);
            switch (type) {
                case 'login':
                case 'sendMessage':
                    _this.eventEmitter.emit(type, packet.body);
                    break;
                case 'serverPush': {
                    _this.send({
                        type: template_1.MessageType.MESSAGE_ACK,
                        requestId: packet.requestId
                    });
                    var content = packet.body;
                    var eventType = type;
                    if (content.msgType === 'forceLogout') {
                        eventType = 'forceLogout';
                        _this.loginStatus = 'forceLogout';
                        _this.close(false);
                    }
                    _this.eventEmitter.emit(eventType, content);
                    break;
                }
                case 'heartbeat':
                    _this.eventEmitter.emit(type, packet);
                    break;
                default:
                    break;
            }
        };
        _this._onHeartbeat = function () {
            _this.clearHeartbeat();
        };
        _this.verifyLogin();
        _this.on('open', function () {
            _this.sendLogin();
        });
        _this.on('connecting', function () { return (_this.loginStatus = 'none'); });
        _this.on('reconnect', function () { return (_this.loginStatus = 'none'); });
        _this.on('packet', _this._onPacket);
        _this.on('heartbeat', _this._onHeartbeat);
        _this.on('error', function () {
            _this.loginStatus = 'none';
            _this.stopHeartbeat();
        });
        _this.on('close', function () {
            _this.loginStatus = 'none';
            _this.messageQueue = [];
            _this.stopHeartbeat();
        });
        return _this;
    }
    Client.prototype.verifyLogin = function () {
        if (!this.login.token) {
            throw new Error('token 不能为空');
        }
        if (!this.login.endPoint) {
            throw new Error('endPoint 不能为空');
        }
    };
    Client.prototype.sendLogin = function () {
        var _this = this;
        if (this.loginStatus !== 'none') {
            throw new Error("Login status is " + this.loginStatus);
        }
        this.eventEmitter.emit('authorizing');
        this.loginStatus = 'authorizing';
        this.once('login', function (body) {
            // console.log('login', body);
            if (body.code === 200) {
                _this.sendHeartbeat();
                _this.loginStatus = 'success';
                _this.messageQueue.forEach(function (_a) {
                    var data = _a.data, resolve = _a.resolve, reject = _a.reject;
                    _this.promiseSend(data)
                        .then(function (data) { return resolve(data.body); })
                        .catch(function (e) { return reject(e); });
                });
                _this.eventEmitter.emit('loginSuccess', body);
            }
            else {
                _this.loginStatus = 'fail';
                _this.eventEmitter.emit('loginFail', body);
            }
        });
        this.promiseSend(__assign(__assign({}, template_1.template.login), { requestId: utils_1.uniqueId('login-'), body: this.login }), this.option.loginTimeout).catch(function (e) {
            _this.loginStatus = 'fail';
            _this.eventEmitter.emit('loginFail', e);
        });
    };
    Client.prototype.clearHeartbeat = function () {
        this.timeoutCount = 0;
        for (var _i = 0, _a = this.heartbeatQueue; _i < _a.length; _i++) {
            var timer = _a[_i];
            clearTimeout(timer);
        }
        this.heartbeatQueue = [];
    };
    Client.prototype.sendHeartbeat = function () {
        var _this = this;
        var requestId = utils_1.uniqueId('heartbeat-');
        var timer = setTimeout(function () {
            _this.timeoutCount += 1;
            if (_this.timeoutCount > _this.option.maxBeatTimeoutTimes) {
                _this.close(true);
            }
        }, this.option.beatTimeout);
        this.heartbeatQueue.push(timer);
        this.send(__assign(__assign({}, template_1.template.heartbeat), { requestId: requestId }));
        this.heartbeatTimer = setTimeout(function () { return _this.sendHeartbeat(); }, this.option.beatInterval);
    };
    Client.prototype.stopHeartbeat = function () {
        this.heartbeatTimer && clearTimeout(this.heartbeatTimer);
        this.heartbeatTimer = null;
        this.clearHeartbeat();
    };
    Client.prototype.sendMessage = function (message) {
        var _this = this;
        var data = __assign(__assign({}, template_1.template.sendMessage), { requestId: utils_1.uniqueId('message-'), body: message });
        if (['none', 'authorizing'].indexOf(this.loginStatus) > -1) {
            var sendMessagePromise = new Promise(function (resolve, reject) {
                _this.messageQueue.push({ data: data, resolve: resolve, reject: reject });
            });
            return sendMessagePromise;
        }
        return this.promiseSend(data).then(function (data) { return data.body; });
    };
    return Client;
}(PromiseClient_1.PromiseClient));
exports.Client = Client;
exports.default = Client;
//# sourceMappingURL=Client.js.map